import { GraphicProcessor } from "lib/graphic-processor";
import { IObjData } from "lib/models/objdata";
import { LayerData } from "../layer-data";

export class LayerChangeLock {

  private graphicProcessor: GraphicProcessor;

  constructor(graphicProcessor: GraphicProcessor) {
    this.graphicProcessor = graphicProcessor;
  }

  run(layerId: string, isLocked: boolean) {
    const layerManager = this.graphicProcessor.getLayerManager();
    const layer = layerManager.getLayerDataFromId(layerId);
    if (layer && layer.locked !== isLocked) {
      layer.locked = isLocked;

      const objDatas: IObjData[] = [];
      layerManager.iterAllLayers((layerData: LayerData) => {
        for (const objData of layerData.objDatas) {
          const lyrs = layerManager.getParentLayersDataFromId(objData.layerId);
          if (lyrs) {
            const isLocked = lyrs.some(lyr => lyr.locked);
            objData.isLayerLocked = isLocked;
            if (isLocked) objDatas.push(objData);
          }
        }
      }, layer.id);

      const selectionManager = this.graphicProcessor.getSelectionManager();
      selectionManager.unSelectObjDatas(objDatas);

      layerManager.layerObserver.dispatchLockLayerEvent(layer, isLocked);
    }
  }
}